// Translation data for DE/FR forms
export const translations = {
  de: {
    // Header
    title: 'Website Anfrage',
    subtitle: 'Fortschritt',
    bitteWaehlen: 'Bitte wählen',
    ui: {
      headerMenuAriaLabel: 'Hauptmenü',
      headerBadgeAriaLabel: 'Vertrauliches Projektbriefing',
      headerBadgeText: 'Website-Anfrage',
      languageMenuLabel: 'Sprachauswahl',
      progressAriaLabel: 'Formularfortschritt',
      progressLabel: 'Fortschritt',
      footerOrgLine: 'DiGiTaL e.V. - Digitalisierung & Innovation fuer Alle',
      footerProjectLine: 'Website-Anfrage & Projektdokumentation - Vertraulich',
      footerCopyrightPrefix: 'Copyright 2026 DiGiTaL e.V. - Alle Rechte vorbehalten -',
      footerPrivacy: 'Datenschutz',
      footerImprint: 'Impressum',
      goTopAriaLabel: 'Nach oben scrollen',
      goTopLabel: 'Nach oben'
    },
    
    // Form Sections
    contact: {
      title: '1. Kontaktdaten',
      vereinsname: 'Vereinsname / Organisation',
      vereinsnamePlaceholder: 'z.B. Kamerunische Gemeinschaft im Saarland e.V.',
      gruendungsjahr: 'Gründungsjahr (optional)',
      ansprechpartner: 'Ansprechpartner*',
      ansprechpartnerPlaceholder: 'Vor- und Nachname',
      position: 'Position / Rolle (optional)',
      email: 'E-Mail-Adresse*',
      telefon: 'Telefon (optional)',
      webseite_aktuell: 'Aktuelle Website (falls vorhanden)',
      standort: 'Standort / Region',
      adresse: 'Adresse (optional)'
    },
    
    projectType: {
      title: '2. Projekt-Typ & Ziele',
      subtitle1: '2.1 Was benötigen Sie?',
      neue_website: 'Neue Website erstellen',
      relaunch: 'Bestehende Website überarbeiten (Relaunch)',
      redesign: 'Nur Design-Update (Redesign)',
      erweiterung: 'Funktionserweiterung einer bestehenden Website',
      andere: 'Andere',
      andere_placeholder: 'Bitte beschreiben',
      subtitle2: '2.2 Hauptziel der Website',
      beschreibung: 'Projekt-Beschreibung*',
      beschreibungPlaceholder: 'Beschreiben Sie kurz, was Sie mit der Website erreichen möchten...'
    },
    
    organization: {
      title: '3. Geschäftskontext',
      subtitle: 'Hintergrund, Zielgruppe und Wettbewerb',
      subtitle1: '3.1 Vereins- / Unternehmensbeschreibung',
      branche: 'Branche / Bereich',
      branchePlaceholder: 'z.B. Kulturverein, gemeinnützige Organisation',
      dienstleistungen: 'Welche Dienstleistungen / Angebote bieten Sie an?',
      dienstleistungenPlaceholder: 'Beschreiben Sie Ihre Hauptangebote...',
      taetigkeitsgebiete: 'In welchen Regionen / Ländern sind Sie tätig?',
      taetigkeitsgebietePlaceholder: 'z.B. Saarland, bundesweit, Europa',
      subtitle2: '3.2 Zielgruppe',
      zielgruppeTyp: 'Wer wird die Website hauptsächlich nutzen?',
      zielgruppeOptions: [
        { value: 'privatkunden', label: 'Privatkunden / Bürger' },
        { value: 'geschaeftskunden', label: 'Geschäftskunden / B2B' },
        { value: 'mitglieder', label: 'Vereinsmitglieder' },
        { value: 'interessierte', label: 'Interessierte / Besucher' },
        { value: 'oeffentlicher-sektor', label: 'Öffentlicher Sektor' },
        { value: 'partner', label: 'Partner / Kooperationen' },
        { value: 'spender', label: 'Spender / Förderer' },
        { value: 'presse', label: 'Presse / Medien' }
      ],
      zg_alter: 'Altersgruppe',
      zg_alterPlaceholder: 'z.B. 25–55 Jahre',
      zg_standort: 'Standort / Region',
      zg_standortPlaceholder: 'z.B. Saarland, Deutschland',
      zg_sprache: 'Sprache(n)',
      zg_sprachePlaceholder: 'z.B. Deutsch, Französisch',
      zg_technik: 'Technisches Niveau',
      zg_technikOptions: [
        { value: 'niedrig', label: 'Niedrig (wenig Interneterfahrung)' },
        { value: 'mittel', label: 'Mittel (normaler Internetnutzer)' },
        { value: 'hoch', label: 'Hoch (digital affin)' },
        { value: 'gemischt', label: 'Gemischt' }
      ],
      zg_beduerfnisse: 'Bedürfnisse und Schmerzpunkte der Zielgruppe',
      zg_beduerfnissePlaceholder: 'Was suchen Ihre Besucher?',
      subtitle3: '3.3 Wettbewerb / ähnliche Websites',
      konkurrenz: 'Nennen Sie 3–5 ähnliche Websites',
      konkurrenz_analyse: 'Was gefällt / missfällt Ihnen an diesen Websites?',
      konkurrenz_analysePlaceholder: 'Was machen diese Websites gut?'
    },
    
    content: {
      title: '4. Website-Umfang',
      subtitle: 'Welche Seiten, Inhalte und Sprachen?',
      subtitle1: '4.1 Benötigte Seiten',
      seitenLabel: 'Welche Seiten soll die Website enthalten?',
      seitenOptions: [
        { value: 'home', label: 'Startseite / Home' },
        { value: 'ueber-uns', label: 'Über uns / Geschichte' },
        { value: 'vorstand-team', label: 'Vorstand / Team' },
        { value: 'aktivitaeten', label: 'Aktivitäten / Programme' },
        { value: 'veranstaltungen', label: 'Veranstaltungskalender' },
        { value: 'galerie', label: 'Foto- / Videogalerie' },
        { value: 'news-blog', label: 'News / Blog' },
        { value: 'kontakt', label: 'Kontakt' },
        { value: 'impressum', label: 'Impressum / Datenschutz' }
      ],
      seiten_weitere: 'Weitere Seiten',
      seiten_weiterePlaceholder: 'z.B. FAQ, Downloads, Partner...',
      subtitle2: '4.2 Sprachversion(en)',
      sprachenLabel: 'In welchen Sprachen soll die Website verfügbar sein?',
      sprachenOptions: [
        { value: 'deutsch', label: 'Deutsch' },
        { value: 'englisch', label: 'Englisch' },
        { value: 'franzoesisch', label: 'Französisch' },
        { value: 'spanisch', label: 'Spanisch' },
        { value: 'italienisch', label: 'Italienisch' },
        { value: 'andere', label: 'Andere' }
      ],
      lang_andere_text: 'Welche andere Sprache(n)?',
      lang_andere_textPlaceholder: 'z.B. Polnisch, Türkisch...',
      content_bereitstellung: 'Wer stellt die Inhalte bereit?',
      content_bereitstellungOptions: [
        { value: 'wir-liefern-alles', label: 'Wir liefern alle Inhalte fertig' },
        { value: 'wir-liefern-teilweise', label: 'Wir liefern teilweise, Unterstützung gewünscht' },
        { value: 'vollservice', label: 'Vollservice: Texte, Bilder, alles erstellen lassen' }
      ]
    },
    
    design: {
      title: '5. Design & Branding',
      subtitle: 'Look & Feel der Website',
      subtitle1: '5.1 Design-Stil',
      designStilLabel: 'Welcher Stil spricht Sie an?',
      designStilOptions: [
        { value: 'modern-clean', label: 'Modern & Clean' },
        { value: 'klassisch', label: 'Klassisch & Traditionell' },
        { value: 'kreativ', label: 'Kreativ & Spielerisch' },
        { value: 'corporate', label: 'Corporate & Professionell' },
        { value: 'minimalistisch', label: 'Minimalistisch' },
        { value: 'elegant', label: 'Elegant & Zurückhaltend' },
        { value: 'bold-auffaellig', label: 'Bold & Auffällig' }
      ],
      stil_beschreibung: 'Eigene Stilbeschreibung',
      stil_beschreibungPlaceholder: 'Beschreiben Sie Ihre Designvorstellung...',
      farbschema: 'Gewünschte Farben / Farbschema',
      farbschemaPlaceholder: 'z.B. Grün/Gelb/Rot, Blau/Weiß...',
      farbschemaHelp: 'Hex-Codes oder Farbnamen sind willkommen',
      subtitle2: '5.2 Markenauftritt / Branding',
      brandingVorhandenLabel: 'Welche Markenmaterialien sind bereits vorhanden?',
      brandingVorhandenOptions: [
        { value: 'logo-hochqualitaet', label: 'Logo (hohe Qualität / Vektordatei)' },
        { value: 'logo-niedrig', label: 'Logo (nur niedrige Qualität)' },
        { value: 'farbpalette', label: 'Farbpalette definiert' },
        { value: 'typografie', label: 'Typografie / Schriften' },
        { value: 'brand-guidelines', label: 'Brand Guidelines / CI-Handbuch' },
        { value: 'bildarchiv', label: 'Bildarchiv / Fotobibliothek' },
        { value: 'noch-nichts', label: 'Noch nichts vorhanden' }
      ],
      subtitle3: '5.3 Referenz-Websites',
      referenzenLabel: 'Websites, die Ihnen gefallen – und warum',
      gefaelltGrundPlaceholder: 'Was gefällt daran?'
    },
    
    features: {
      title: '6. Funktionale Anforderungen',
      subtitle: 'Welche Funktionen, Features und Formulare?',
      subtitle1: '6.1 Standard-Features',
      featuresLabel: 'Welche Funktionen soll die Website haben?',
      featuresOptions: [
        { value: 'kontaktformular', label: 'Kontaktformular' },
        { value: 'newsletter', label: 'Newsletter-Anmeldung' },
        { value: 'blog-news', label: 'Blog / News-System' },
        { value: 'suchfunktion', label: 'Suchfunktion' },
        { value: 'mehrsprachigkeit', label: 'Mehrsprachige Website' },
        { value: 'cookie-banner', label: 'Cookie-Consent-Banner' },
        { value: 'google-maps', label: 'Google Maps Integration' },
        { value: 'social-media-links', label: 'Social Media Links / Feed' },
        { value: 'downloadbereich', label: 'Download-Bereich' },
        { value: 'bildgalerie', label: 'Bildgalerie / Fotoalbum' },
        { value: 'videogalerie', label: 'Videogalerie' },
        { value: 'veranstaltungskalender', label: 'Veranstaltungskalender' }
      ],
      features_weitere: 'Weitere Features',
      features_weiterePlaceholder: 'z.B. Live-Chat, Forum...',
      subtitle2: '6.2 Formulare & Interaktion',
      formulareLabel: 'Welche Formulare werden benötigt?',
      formulareOptions: [
        { value: 'kontakt', label: 'Kontaktformular' },
        { value: 'newsletter', label: 'Newsletter-Anmeldung' },
        { value: 'mitglied-werden', label: 'Mitglied werden' },
        { value: 'anmeldung-event', label: 'Anmeldung zu Events' },
        { value: 'spende', label: 'Spendenformular' },
        { value: 'bewerbung', label: 'Bewerbungsformular' },
        { value: 'feedback', label: 'Feedback / Umfrage' }
      ],
      formulare_weitere: 'Weitere Formulare',
      formulare_weiterePlaceholder: 'Beschreiben Sie spezielle Formulare...'
    },
    
    tech: {
      title: '7. Technologie & CMS',
      subtitle: 'Technische Präferenzen und System-Anforderungen',
      subtitle1: '7.1 Bevorzugte Technologie',
      technologieLabel: 'Haben Sie eine bevorzugte Technologie?',
      technologieOptions: [
        { value: 'keine-praeferenz', label: 'Keine Präferenz – bitte empfehlen' },
        { value: 'wordpress', label: 'WordPress' },
        { value: 'webflow', label: 'Webflow' },
        { value: 'shopify', label: 'Shopify' },
        { value: 'woocommerce', label: 'WooCommerce' },
        { value: 'headless-cms', label: 'Headless CMS' },
        { value: 'nextjs', label: 'Next.js' },
        { value: 'react', label: 'React' },
        { value: 'vue', label: 'Vue.js' }
      ],
      tech_weitere: 'Andere Technologie / Begründung',
      tech_weiterePlaceholder: 'z.B. Typo3, Joomla...',
      subtitle2: '7.2 CMS-Anforderungen',
      cmsBenoetigt: 'Möchten Sie Inhalte selbst pflegen können?',
      cmsOptions: [
        { value: 'ja', label: 'Ja, vollständig' },
        { value: 'teilweise', label: 'Nur bestimmte Bereiche' },
        { value: 'nein', label: 'Nein, externe Pflege bevorzugt' },
        { value: 'unsicher', label: 'Nicht sicher' }
      ],
      cmsNutzerLabel: 'Wer wird Inhalte im CMS verwalten?',
      cmsNutzerOptions: [
        { value: 'vorstand', label: 'Vorstand / Vereinsleitung' },
        { value: 'marketing', label: 'Marketing / Kommunikation' },
        { value: 'it-team', label: 'IT-Team' },
        { value: 'externe-agentur', label: 'Externe Agentur' },
        { value: 'ehrenamtliche', label: 'Ehrenamtliche Mitglieder' }
      ],
      subtitle3: '7.3 Integrationen',
      integrationenLabel: 'Welche Systeme sollen integriert werden?',
      integrationenOptions: [
        { value: 'crm', label: 'CRM-System' },
        { value: 'erp', label: 'ERP-System' },
        { value: 'zahlungsanbieter', label: 'Zahlungsanbieter' },
        { value: 'newsletter-tool', label: 'Newsletter-Tool' },
        { value: 'marketing-automation', label: 'Marketing-Automation' },
        { value: 'analytics', label: 'Analytics (GA4 / Matomo)' },
        { value: 'buchungssystem', label: 'Buchungssystem' },
        { value: 'social-media-api', label: 'Social Media APIs' }
      ],
      integrationen_liste: 'Details zu benötigten Integrationen',
      integrationen_listePlaceholder: 'Beschreiben Sie welche Systeme integriert werden sollen...'
    },
    
    timeline: {
      title: '15. Zeitplan & Budget',
      subtitle: 'Wann soll die Website live gehen und welches Budget steht zur Verfügung?',
      launch_zeitraum: 'Gewünschter Launch-Zeitraum',
      launch_zeitraumOptions: [
        { value: 'sofort', label: 'So schnell wie möglich' },
        { value: '1_3_monate', label: '1–3 Monate' },
        { value: '3_6_monate', label: '3–6 Monate' },
        { value: '6_12_monate', label: '6–12 Monate' },
        { value: 'flexibel', label: 'Flexibel / Noch nicht sicher' }
      ],
      launch_datum: 'Konkretes Launch-Datum (falls vorhanden)',
      deadline_grund: 'Grund für feste Deadline',
      deadline_grundPlaceholder: 'z.B. Event, Kampagne, Geschäftsjahr...',
      budget_rahmen: 'Budget-Rahmen',
      budget_rahmenOptions: [
        { value: 'unter-5k', label: 'Unter 5.000 €' },
        { value: '5k-15k', label: '5.000 € – 15.000 €' },
        { value: '15k-30k', label: '15.000 € – 30.000 €' },
        { value: '30k-50k', label: '30.000 € – 50.000 €' },
        { value: 'ueber-50k', label: 'Über 50.000 €' },
        { value: 'noch-offen', label: 'Noch nicht festgelegt' }
      ],
      budget_aufteilung: 'Wie soll das Budget aufgeteilt werden?',
      budget_aufteilungPlaceholder: 'z.B. 40% Design, 40% Entwicklung, 20% Content...'
    },
    
    shop: {
      title: '8. E-Commerce-Anforderungen',
      subtitle: 'Nur ausfüllen, wenn ein Online-Shop oder Zahlungsfunktionen benötigt werden',
      shopBenoetigt: 'Wird ein Online-Shop oder Online-Zahlung benötigt?',
      shopOptionen: [
        { value: 'ja', label: 'Ja' },
        { value: 'nein', label: 'Nein' },
        { value: 'spaeter', label: 'Später / in Zukunft' }
      ],
      subtitle1: '8.1 Produkt-Informationen',
      produktAnzahl: 'Anzahl der Produkte / Artikel',
      produktAnzahlOptionen: [
        { value: '1-10', label: '1–10' },
        { value: '11-50', label: '11–50' },
        { value: '51-200', label: '51–200' },
        { value: '201-1000', label: '201–1.000' },
        { value: '1000+', label: '1.000+' }
      ],
      produktTyp: 'Art der Produkte / Leistungen',
      produktTypOptionen: [
        { value: 'physische-produkte', label: 'Physische Produkte' },
        { value: 'digitale-produkte', label: 'Digitale Produkte / Downloads' },
        { value: 'dienstleistungen', label: 'Dienstleistungen' },
        { value: 'abonnements', label: 'Abonnements / Mitgliedsbeiträge' },
        { value: 'buchungen', label: 'Buchungen / Reservierungen' },
        { value: 'spenden', label: 'Spenden / Förderungen' },
        { value: 'tickets-events', label: 'Tickets / Veranstaltungen' },
        { value: 'individuelle-produkte', label: 'Individuelle / konfigurierbare Produkte' }
      ],
      subtitle2: '8.2 Shop-Features',
      shopFeatures: 'Welche Shop-Funktionen werden benötigt?',
      shopFeaturesOptionen: [
        { value: 'produktkategorien', label: 'Produktkategorien' },
        { value: 'produktfilter', label: 'Produktfilter / Suche' },
        { value: 'warenkorb', label: 'Warenkorb' },
        { value: 'checkout', label: 'Checkout-Prozess' },
        { value: 'kundenkonto', label: 'Kundenkonto' },
        { value: 'gast-checkout', label: 'Gast-Checkout' },
        { value: 'rabattcodes', label: 'Rabattcodes / Gutscheine' },
        { value: 'produktbewertungen', label: 'Produktbewertungen' },
        { value: 'wunschliste', label: 'Wunschliste' },
        { value: 'lagerverwaltung', label: 'Lagerverwaltung' },
        { value: 'versandregeln', label: 'Versandregeln / -kosten' },
        { value: 'steuerberechnung', label: 'Steuerberechnung' },
        { value: 'rechnungserstellung', label: 'Automatische Rechnungserstellung' },
        { value: 'rueckgabeprozess', label: 'Rückgabe- / Stornoprozess' },
        { value: 'mehrwaehrung', label: 'Mehrwährung' },
        { value: 'b2b-preise', label: 'B2B-Preise / Kundengruppen' }
      ],
      zahlungsmethoden: 'Gewünschte Zahlungsmethoden',
      zahlungsmethodenOptionen: [
        { value: 'kreditkarte', label: 'Kreditkarte (Visa / Mastercard)' },
        { value: 'paypal', label: 'PayPal' },
        { value: 'apple-pay', label: 'Apple Pay' },
        { value: 'google-pay', label: 'Google Pay' },
        { value: 'klarna', label: 'Klarna' },
        { value: 'sepa-lastschrift', label: 'SEPA-Lastschrift' },
        { value: 'bankueberweisung', label: 'Banküberweisung' },
        { value: 'kauf-auf-rechnung', label: 'Kauf auf Rechnung' }
      ],
      zahlungsmethodenWeitere: 'Andere Zahlungsmethoden ...',
      versandanbieter: 'Versandanbieter (falls physische Produkte)',
      versandanbieterPlaceholder: 'z.B. DHL, DPD, Hermes, UPS, oder nicht relevant'
    },
    
    compliance: {
      title: '9. Sicherheit, Compliance & Datenschutz',
      subtitle: 'DSGVO, rechtliche Anforderungen und Sicherheitsmaßnahmen',
      subtitle1: '9.1 Compliance-Anforderungen',
      complianceAnforderungen: 'Welche rechtlichen und regulatorischen Anforderungen gelten?',
      complianceOptionen: [
        { value: 'dsgvo', label: 'DSGVO (EU-Datenschutz)' },
        { value: 'cookie-consent', label: 'Cookie-Consent-Management' },
        { value: 'barrierefreiheit', label: 'Barrierefreiheit (WCAG)' },
        { value: 'wcag-2-1-aa', label: 'WCAG 2.1 AA Standard' },
        { value: 'impressum', label: 'Vollständiges Impressum' },
        { value: 'datenschutzerklaerung', label: 'Datenschutzerklärung' },
        { value: 'agb', label: 'AGB / Nutzungsbedingungen' },
        { value: 'auftragsverarbeitung', label: 'Auftragsverarbeitungsvertrag (AVV)' },
        { value: 'oeffentlicher-sektor', label: 'Öffentlicher Sektor / Behörden' },
        { value: 'branchenspezifisch', label: 'Branchenspezifische Compliance' },
        { value: 'hipaa-gesundheit', label: 'HIPAA / Gesundheitsdaten' },
        { value: 'finanz-compliance', label: 'Finanz-Compliance' }
      ],
      complianceWeitere: 'Weitere Compliance-Anforderungen',
      complianceWeiterePlaceholder: 'z.B. ISO 27001, gemeinnützige Auflagen, Vereinsrecht ...',
      subtitle2: '9.2 Sicherheitsanforderungen',
      sicherheitsFeatures: 'Welche Sicherheits-Features werden benötigt?',
      sicherheitOptionen: [
        { value: 'ssl-https', label: 'SSL / HTTPS' },
        { value: 'sichere-formulare', label: 'Sichere Formulare (CSRF-Schutz)' },
        { value: 'spam-schutz', label: 'Spam-Schutz (reCAPTCHA)' },
        { value: 'web-application-firewall', label: 'Web Application Firewall (WAF)' },
        { value: 'rollenbasierter-zugriff', label: 'Rollenbasierte Zugriffskontrolle' },
        { value: 'zwei-faktor-auth', label: 'Zwei-Faktor-Authentifizierung (2FA)' },
        { value: 'audit-logs', label: 'Audit-Logs / Aktivitätsprotokolle' },
        { value: 'backup-strategie', label: 'Backup-Strategie' },
        { value: 'malware-schutz', label: 'Malware-Schutz' },
        { value: 'sicherheits-monitoring', label: 'Sicherheits-Monitoring' },
        { value: 'penetrationstest', label: 'Penetrationstest' },
        { value: 'vulnerability-scanning', label: 'Vulnerability Scanning' },
        { value: 'sichere-api-auth', label: 'Sichere API-Authentifizierung' }
      ],
      sensibleDaten: 'Werden sensible Daten verarbeitet?',
      sensibleDatenOptionen: [
        { value: 'keine-sensiblen-daten', label: 'Nein / keine sensiblen Daten' },
        { value: 'personendaten', label: 'Personenbezogene Daten' },
        { value: 'zahlungsdaten', label: 'Zahlungsdaten' },
        { value: 'gesundheitsdaten', label: 'Gesundheitsdaten' },
        { value: 'mitarbeiterdaten', label: 'Mitarbeiterdaten' },
        { value: 'kundendaten-vertraulich', label: 'Vertrauliche Kundendaten' },
        { value: 'kinderdaten', label: 'Daten von Minderjährigen' }
      ],
      datenschutzAnmerkungen: 'Besondere Datenschutz-Anforderungen oder Anmerkungen',
      datenschutzAnmerkungenPlaceholder: 'z.B. Daten dürfen nur auf deutschen Servern gespeichert werden, spezielle Löschfristen, externe Datenschutzbeauftragter vorhanden ...'
    },
    
    seo: {
      title: '10. SEO & Digital Marketing',
      subtitle: 'Suchmaschinenoptimierung, Tracking und Marketing-Tools',
      subtitle1: '10.1 SEO-Anforderungen',
      seoLeistungen: 'Welche SEO-Leistungen werden benötigt?',
      seoOptionen: [
        { value: 'technisches-seo', label: 'Technisches SEO (Grundlagen)' },
        { value: 'keyword-recherche', label: 'Keyword-Recherche' },
        { value: 'seo-content', label: 'SEO-optimierte Texterstellung' },
        { value: 'lokales-seo', label: 'Lokales SEO (Google Maps / Local)' },
        { value: 'internationales-seo', label: 'Internationales SEO / hreflang' },
        { value: 'seo-migration', label: 'SEO-Migration (alte Website)' },
        { value: 'redirect-strategie', label: 'Redirect-Strategie (301-Weiterleitungen)' },
        { value: 'metadata-optimierung', label: 'Metadata-Optimierung (Title / Description)' },
        { value: 'structured-data', label: 'Structured Data / Schema Markup' },
        { value: 'core-web-vitals', label: 'Core Web Vitals Optimierung' },
        { value: 'google-search-console', label: 'Google Search Console Einrichtung' },
        { value: 'google-my-business', label: 'Google My Business Optimierung' }
      ],
      seoKeywords: 'Wichtige Suchbegriffe / Keywords',
      seoKeywordsPlaceholder: 'Für welche Suchbegriffe soll Ihre Website bei Google gefunden werden?\nz.B. \'Kamerunischer Verein Saarland\', \'Kulturverein Saarbrücken\', \'Afrika Gemeinschaft Saar\'',
      seoKeywordsHelp: 'Je mehr Begriffe, desto genauer können wir die SEO-Strategie planen.',
      seoZielregion: 'Zielregion für SEO',
      seoZielregionPlaceholder: 'z.B. Saarland, Deutschland, deutschsprachiger Raum, Europa, international',
      subtitle2: '10.2 Marketing-Tools & Tracking',
      marketingTools: 'Welche Marketing- und Tracking-Tools sollen integriert werden?',
      marketingToolsOptionen: [
        { value: 'google-analytics-4', label: 'Google Analytics 4 (GA4)' },
        { value: 'google-tag-manager', label: 'Google Tag Manager' },
        { value: 'matomo', label: 'Matomo (DSGVO-konform)' },
        { value: 'meta-pixel', label: 'Meta Pixel (Facebook / Instagram)' },
        { value: 'linkedin-insight', label: 'LinkedIn Insight Tag' },
        { value: 'google-ads', label: 'Google Ads Conversion-Tracking' },
        { value: 'newsletter-integration', label: 'Newsletter-Tool-Integration' },
        { value: 'crm-tracking', label: 'CRM-Tracking' },
        { value: 'conversion-tracking', label: 'Conversion-Tracking' },
        { value: 'ab-testing', label: 'A/B-Testing' },
        { value: 'heatmaps', label: 'Heatmaps (z.B. Hotjar / Microsoft Clarity)' },
        { value: 'keine-tools', label: 'Keine Marketing-Tools benötigt' }
      ],
      socialMedia: 'Social Media Präsenz (bestehende Kanäle)',
      socialMediaOptionen: [
        { value: 'facebook', label: 'Facebook' },
        { value: 'instagram', label: 'Instagram' },
        { value: 'youtube', label: 'YouTube' },
        { value: 'linkedin', label: 'LinkedIn' },
        { value: 'twitter-x', label: 'Twitter / X' },
        { value: 'tiktok', label: 'TikTok' },
        { value: 'whatsapp', label: 'WhatsApp / WhatsApp Business' },
        { value: 'noch-keine', label: 'Noch keine Social-Media-Präsenz' }
      ],
      socialMediaUrls: 'Social-Media-URLs (optional): z.B. facebook.com/kgs-saarland ...'
    },
    
    performance: {
      title: '11. Performance & Hosting',
      subtitle: 'Erwartete Besucherzahlen, Hosting-Präferenzen und Leistungsanforderungen',
      subtitle1: '11.1 Hosting-Anforderungen',
      hostingStatus: 'Ist bereits ein Hosting vorhanden?',
      hostingStatusOptionen: [
        { value: 'ja', label: 'Ja, bestehendes Hosting' },
        { value: 'nein', label: 'Nein, wird benötigt' },
        { value: 'unsicher', label: 'Nicht sicher' },
        { value: 'empfehlung', label: 'Bitte empfehlen' }
      ],
      hostingTyp: 'Bevorzugter Hosting-Typ',
      hostingTypOptionen: [
        { value: 'shared-hosting', label: 'Shared Hosting' },
        { value: 'managed-hosting', label: 'Managed Hosting' },
        { value: 'vps', label: 'VPS (Virtual Private Server)' },
        { value: 'cloud-hosting', label: 'Cloud Hosting' },
        { value: 'aws', label: 'AWS' },
        { value: 'azure', label: 'Microsoft Azure' },
        { value: 'google-cloud', label: 'Google Cloud' },
        { value: 'vercel', label: 'Vercel / Netlify' },
        { value: 'hetzner', label: 'Hetzner (Deutschland)' },
        { value: 'dedicated-server', label: 'Dedicated Server' },
        { value: 'keine-praeferenz', label: 'Keine Präferenz' }
      ],
      hostingTypHelp: 'Für DSGVO-Konformität empfehlen wir Server-Standort Deutschland / EU.',
      emailHosting: 'Werden professionelle E-Mail-Adressen benötigt?',
      emailHostingOptionen: [
        { value: 'ja', label: 'Ja (z.B. info@kgs-saarland.de)' },
        { value: 'nein', label: 'Nein, bestehende E-Mails reichen' }
      ],
      subtitle2: '11.2 Performance-Erwartungen',
      traffic: 'Erwartete Besucherzahl pro Monat',
      trafficOptionen: [
        { value: 'unter-1000', label: 'Unter 1.000 Besucher' },
        { value: '1000-10000', label: '1.000–10.000 Besucher' },
        { value: '10000-100000', label: '10.000–100.000 Besucher' },
        { value: '100000+', label: '100.000+ Besucher' },
        { value: 'unbekannt', label: 'Nicht bekannt' }
      ],
      performanceAnforderungen: 'Performance-Anforderungen',
      performanceOptionen: [
        { value: 'schnelle-ladezeit', label: 'Schnelle Ladezeit (< 2 Sekunden)' },
        { value: 'core-web-vitals', label: 'Core Web Vitals Optimierung' },
        { value: 'cdn', label: 'CDN (Content Delivery Network)' },
        { value: 'bild-optimierung', label: 'Bild-Optimierung / WebP' },
        { value: 'caching', label: 'Caching-Strategie' },
        { value: 'high-availability', label: 'Hohe Verfügbarkeit (99,9% Uptime)' },
        { value: 'skalierbare-infrastruktur', label: 'Skalierbare Infrastruktur' },
        { value: 'mobile-optimierung', label: 'Mobile-First Optimierung' }
      ]
    },
    
    accessibility: {
      title: '12. Barrierefreiheit',
      subtitle: 'Zugänglichkeit für alle Nutzergruppen – gesetzliche und freiwillige Anforderungen',
      barrierefreiheitNiveau: 'Welches Barrierefreiheits-Niveau wird angestrebt?',
      barrierefreiheitOptionen: [
        { value: 'keine', label: 'Keine besonderen Anforderungen' },
        { value: 'basis', label: 'Basis-Barrierefreiheit' },
        { value: 'wcag-2-1-aa', label: 'WCAG 2.1 AA' },
        { value: 'wcag-2-2-aa', label: 'WCAG 2.2 AA' },
        { value: 'oeffentlicher-sektor', label: 'Öffentlicher Sektor (gesetzlich)' },
        { value: 'nicht-sicher', label: 'Nicht sicher' }
      ],
      a11yFeatures: 'Benötigte Barrierefreiheits-Features',
      a11yFeaturesOptionen: [
        { value: 'tastaturnavigation', label: 'Tastaturnavigation' },
        { value: 'screenreader', label: 'Screenreader-Unterstützung' },
        { value: 'farbkontrast', label: 'Ausreichende Farbkontraste' },
        { value: 'barrierefreie-formulare', label: 'Barrierefreie Formulare' },
        { value: 'alt-texte', label: 'Alt-Texte für alle Bilder' },
        { value: 'barrierefreie-pdfs', label: 'Barrierefreie PDFs' },
        { value: 'video-untertitel', label: 'Video-Untertitel / Captions' },
        { value: 'fokus-indikatoren', label: 'Sichtbare Fokus-Indikatoren' },
        { value: 'aria-labels', label: 'ARIA-Labels / Semantisches HTML' },
        { value: 'anpassbare-schriftgroesse', label: 'Anpassbare Schriftgröße' }
      ]
    },
    
    migration: {
      title: '13. Migration & Bestandsdaten',
      subtitle: 'Wenn Sie bereits eine Website oder ein System haben, müssen wir verstehen, was übernommen werden soll',
      subtitle1: '13.1 Bestehende Website',
      migrationUrl: 'URL der bestehenden Website (falls vorhanden)',
      migrationBenoetigt: 'Soll eine bestehende Website migriert werden?',
      migrationOptionen: [
        { value: 'ja', label: 'Ja, vollständige Migration' },
        { value: 'teilweise', label: 'Ja, teilweise / ausgewählte Inhalte' },
        { value: 'nein', label: 'Nein, Neustart / keine Migration' }
      ],
      subtitle2: '13.2 Was soll migriert werden?',
      migrationInhalteOptionen: [
        { value: 'seiten', label: 'Seiten & Texte' },
        { value: 'blog', label: 'Blog-Beiträge / News-Artikel' },
        { value: 'bilder', label: 'Bilder & Medien' },
        { value: 'produkte', label: 'Produkte & Produktbeschreibungen' },
        { value: 'kunden', label: 'Kundendaten' },
        { value: 'bestellungen', label: 'Bestellhistorie & Transaktionen' },
        { value: 'seo_urls', label: 'SEO-URLs & Permalinks' },
        { value: 'weiterleitungen', label: '301-Weiterleitungen' },
        { value: 'benutzerkonten', label: 'Benutzerkonten & Passwörter' },
        { value: 'dokumente', label: 'Dokumente & Downloads' },
        { value: 'datenbank', label: 'Datenbank / strukturierte Daten' },
        { value: 'formulardaten', label: 'Formulardaten & Leads' },
        { value: 'kommentare', label: 'Kommentare & Bewertungen' },
        { value: 'meta_daten', label: 'Meta-Tags & SEO-Daten' }
      ],
      subtitle3: '13.3 Aktuelle Plattform / Technologie',
      aktuellePlattform: 'Auf welcher Plattform läuft die aktuelle Website?',
      plattformOptionen: [
        { value: 'wordpress', label: 'WordPress' },
        { value: 'shopify', label: 'Shopify' },
        { value: 'woocommerce', label: 'WooCommerce' },
        { value: 'wix', label: 'Wix' },
        { value: 'squarespace', label: 'Squarespace' },
        { value: 'webflow', label: 'Webflow' },
        { value: 'joomla', label: 'Joomla' },
        { value: 'typo3', label: 'TYPO3' },
        { value: 'drupal', label: 'Drupal' },
        { value: 'custom', label: 'Eigene Entwicklung / Custom' },
        { value: 'andere', label: 'Andere' },
        { value: 'keine', label: 'Keine bestehende Website' }
      ],
      plattformAndere: 'Welche Plattform?',
      plattformAnderePlaceholder: 'Name der Plattform / Technologie',
      migrationNotizen: 'Besonderheiten oder Hinweise zur Migration',
      migrationNotizenPlaceholder: 'z.B. komplexe URL-Struktur, alte Datenbank-Versionen, besondere Inhaltstypen…'
    },
    
    support: {
      title: '14. Wartung & Support',
      subtitle: 'Klären Sie, welche laufende Betreuung nach dem Launch gewünscht wird',
      subtitle1: '14.1 Gewünschte Support-Leistungen nach Launch',
      supportLeistungenOptionen: [
        { value: 'keine', label: 'Kein Support gewünscht' },
        { value: 'basis_wartung', label: 'Basis-Wartung (Updates, Backups)' },
        { value: 'sicherheits_updates', label: 'Sicherheitsupdates & Patches' },
        { value: 'content_updates', label: 'Inhaltspflege / Redaktionelle Updates' },
        { value: 'seo_monitoring', label: 'SEO-Monitoring & Optimierung' },
        { value: 'performance_monitoring', label: 'Performance-Monitoring' },
        { value: 'analytics', label: 'Analytics-Reporting' },
        { value: 'bug_fixing', label: 'Bug-Fixing & Fehlerbehebung' },
        { value: 'neue_features', label: 'Neue Features & Erweiterungen' },
        { value: 'sla', label: 'SLA / garantierte Reaktionszeiten' },
        { value: 'notfall_support', label: 'Notfall-Support (24/7)' },
        { value: 'hosting_mgmt', label: 'Hosting-Management' },
        { value: 'schulung', label: 'CMS-Schulung & Training' },
        { value: 'dokumentation', label: 'Technische Dokumentation' }
      ],
      subtitle2: '14.2 Bevorzugtes Support-Modell',
      supportModell: 'Wie soll die laufende Betreuung organisiert werden?',
      supportModellOptionen: [
        { value: 'stundenweise', label: 'Stundenweise (nach Aufwand)' },
        { value: 'monatlich_retainer', label: 'Monatliches Retainer-Paket' },
        { value: 'fix_paket', label: 'Festes Wartungspaket (Umfang definiert)' },
        { value: 'enterprise_sla', label: 'Enterprise SLA mit definierten KPIs' },
        { value: 'intern', label: 'Intern betreut (eigenes IT-Team)' },
        { value: 'noch_unklar', label: 'Noch nicht entschieden' }
      ],
      subtitle3: '14.3 Übergabe & Dokumentation',
      uebergabeOptionen: [
        { value: 'admin_schulung', label: 'Admin-Schulung für das Team' },
        { value: 'benutzer_handbuch', label: 'Benutzerhandbuch / Dokumentation' },
        { value: 'technische_doku', label: 'Technische Dokumentation (Architektur, APIs)' },
        { value: 'code_kommentare', label: 'Kommentierter Quellcode' },
        { value: 'video_tutorials', label: 'Video-Tutorials' },
        { value: 'quellcode_uebergabe', label: 'Quellcode-Übergabe (Git Repository)' }
      ]
    },
    
    priorities: {
      title: '16. Entscheidungskriterien & Prioritäten',
      subtitle: 'Bitte bewerten Sie die folgenden Kriterien nach ihrer Wichtigkeit für Ihr Projekt',
      subtitle1: '16.1 Projektziele gewichten',
      unwichtig: 'Unwichtig',
      mittel: 'Mittel',
      sehrWichtig: 'Sehr wichtig',
      priorityItems: [
        { field: 'prio_preis', label: 'Preis / Kosteneffizienz' },
        { field: 'prio_geschwindigkeit', label: 'Geschwindigkeit / Lieferzeit' },
        { field: 'prio_design', label: 'Design-Qualität & Ästhetik' },
        { field: 'prio_technik', label: 'Technische Qualität & Code-Standard' },
        { field: 'prio_seo', label: 'SEO & Auffindbarkeit' },
        { field: 'prio_sicherheit', label: 'Sicherheit & Datenschutz' },
        { field: 'prio_skalierbarkeit', label: 'Skalierbarkeit & Wachstum' },
        { field: 'prio_cms_bedienung', label: 'Einfache CMS-Bedienung' },
        { field: 'prio_support', label: 'Langfristiger Support & Wartung' },
        { field: 'prio_innovation', label: 'Innovation & Moderne Technologie' },
        { field: 'prio_zuverlaessigkeit', label: 'Zuverlässigkeit & Verfügbarkeit' },
        { field: 'prio_compliance', label: 'Enterprise-Compliance & Audit-Fähigkeit' }
      ],
      subtitle2: '16.2 Entscheidungsgrundlage',
      entscheidungsgrund: 'Was ist der primäre Auswahlgrund für einen Dienstleister?',
      entscheidungsgrundOptionen: [
        { value: 'preis', label: 'Bestes Preis-Leistungs-Verhältnis' },
        { value: 'referenzen', label: 'Referenzen & nachgewiesene Erfahrung' },
        { value: 'empfehlung', label: 'Persönliche Empfehlung' },
        { value: 'portfolio', label: 'Design-Portfolio' },
        { value: 'technologie', label: 'Technologiekompetenz' },
        { value: 'kommunikation', label: 'Kommunikation & Projektmanagement' },
        { value: 'langfristig', label: 'Langfristige Partnerschaft' }
      ]
    },
    
    stakeholders: {
      title: '17. Interner Prozess & Entscheidungsstruktur',
      subtitle: 'Damit wir das Projekt effizient begleiten können, benötigen wir Informationen zu Ihrem internen Entscheidungs- und Feedbackprozess',
      subtitle1: '17.1 Feedback & Freigaben',
      feedbackPersonen: 'Wer gibt intern Feedback und Freigaben?',
      feedbackPersonenPlaceholder: 'z.B. Geschäftsführung, Marketing-Leiterin, IT-Abteilung, Vereinsvorstand…',
      feedbackGeschwindigkeit: 'Wie schnell können Feedbacks und Freigaben erteilt werden?',
      feedbackGeschwindigkeitOptionen: [
        { value: 'selber_tag', label: 'Am selben Tag' },
        { value: '1_2_tage', label: '1–2 Werktage' },
        { value: '3_5_tage', label: '3–5 Werktage' },
        { value: '1_woche_plus', label: 'Mehr als 1 Woche' },
        { value: 'unklar', label: 'Noch unklar' }
      ],
      feedbackRunden: 'Wie viele Feedback-Runden sind intern üblich?',
      feedbackRundenOptionen: [
        { value: '1', label: '1 Runde' },
        { value: '2', label: '2 Runden' },
        { value: '3', label: '3 Runden' },
        { value: '4_plus', label: '4+ Runden' },
        { value: 'unklar', label: 'Noch unklar' }
      ],
      subtitle2: '17.2 Interne Stakeholder',
      stakeholderBereiche: 'Welche internen Bereiche sind am Projekt beteiligt?',
      stakeholderOptionen: [
        { value: 'geschaeftsfuehrung', label: 'Geschäftsführung / Vorstand' },
        { value: 'marketing', label: 'Marketing & Kommunikation' },
        { value: 'vertrieb', label: 'Vertrieb / Sales' },
        { value: 'it', label: 'IT-Abteilung' },
        { value: 'recht', label: 'Recht / Legal / Datenschutz' },
        { value: 'hr', label: 'HR / Personal' },
        { value: 'produkt', label: 'Produktmanagement' },
        { value: 'kundensupport', label: 'Kundensupport' },
        { value: 'finanzen', label: 'Finanzen / Einkauf' },
        { value: 'externe_agentur', label: 'Externe Agentur / Berater' }
      ],
      subtitle3: '17.3 Kommunikation & Zusammenarbeit',
      kommunikationsweg: 'Bevorzugter Kommunikationsweg mit dem Entwicklungsteam?',
      kommunikationOptionen: [
        { value: 'email', label: 'E-Mail' },
        { value: 'telefon', label: 'Telefon' },
        { value: 'video_call', label: 'Video-Call (Teams, Zoom, Meet)' },
        { value: 'slack', label: 'Slack / Chat' },
        { value: 'projektmanagement_tool', label: 'Projektmanagement-Tool (Jira, Asana, Trello…)' },
        { value: 'vor_ort', label: 'Vor-Ort-Meetings' }
      ],
      updateFrequenz: 'Wie oft wünschen Sie Status-Updates?',
      updateFrequenzOptionen: [
        { value: 'taeglich', label: 'Täglich' },
        { value: 'woechentlich', label: 'Wöchentlich' },
        { value: 'zweimal_pro_woche', label: 'Zweimal pro Woche' },
        { value: 'bei_meilensteinen', label: 'Nur bei Meilensteinen' },
        { value: 'nach_bedarf', label: 'Nach Bedarf' }
      ]
    },
    
    additional: {
      title: '18. Zusätzliche Informationen',
      subtitle: 'Teilen Sie uns weitere wichtige Details mit, die wir für ein vollständiges Angebot benötigen',
      subtitle1: '18.1 Besondere Wünsche & Anforderungen',
      besondereWuensche: 'Gibt es besondere Wünsche, die noch nicht erwähnt wurden?',
      besondereWuenschePlaceholder: 'z.B. spezifische Technologien, besondere Interaktionen, Gamification-Elemente, innovative Features…',
      subtitle2: '18.2 Aktuelle Herausforderungen',
      herausforderungen: 'Was sind die größten Herausforderungen mit der aktuellen Website oder dem aktuellen Auftritt?',
      herausforderungenPlaceholder: 'z.B. zu langsam, schlechte Auffindbarkeit, nicht mobil-optimiert, veraltetes Design, schwer zu pflegen, keine Conversions…',
      subtitle3: '18.3 Erfolgsmessung',
      erfolgsMessung: 'Woran messen Sie den Erfolg des Projekts?',
      erfolgsMessungPlaceholder: 'z.B. Anzahl Anfragen, Conversion-Rate, organischer Traffic, Absprungrate, Ladezeit, Nutzerzufriedenheit, Umsatz…',
      kpis: 'Welche KPIs / Metriken sind für Sie besonders relevant?',
      kpisPlaceholder: 'z.B. monatliche Besucher, Lead-Rate, Core Web Vitals Score, Google-Ranking Position 1–3…',
      subtitle4: '18.4 Gewünschte Zusatzleistungen',
      zusatzleistungenOptionen: [
        { value: 'wartung', label: 'Laufende Wartung & Updates' },
        { value: 'seo_ongoing', label: 'Fortlaufende SEO-Betreuung' },
        { value: 'social_media', label: 'Social-Media-Integration & Betreuung' },
        { value: 'content_erstellung', label: 'Content-Erstellung & Texte' },
        { value: 'fotografie', label: 'Fotografie & Bildproduktion' },
        { value: 'video', label: 'Video-Produktion' },
        { value: 'cms_schulung', label: 'CMS-Schulung & Training' },
        { value: 'online_marketing', label: 'Online-Marketing (Google Ads, Meta Ads…)' },
        { value: 'email_marketing', label: 'E-Mail-Marketing & Newsletter' },
        { value: 'analytics_setup', label: 'Analytics-Einrichtung & Reporting' }
      ],
      subtitle5: '18.5 Sonstiges',
      sonstiges: 'Gibt es noch weitere wichtige Informationen für uns?',
      sonstigesPlaceholder: 'Alles, was Sie uns noch mitteilen möchten…'
    },
    
    files: {
      title: '19. Dateien & Anhänge',
      subtitle: 'Welche Materialien können Sie für das Projekt bereitstellen?',
      subtitle1: '19.1 Verfügbare Unterlagen',
      verfuegbareHelp: 'Bitte markieren Sie, was bereits vorhanden und bereitstellbar ist.',
      verfuegbareLabel: 'Welche Unterlagen können bereitgestellt werden?',
      unterlagenOptionen: [
        { value: 'logo', label: 'Logo (Vektordatei / SVG / AI / EPS)' },
        { value: 'brand_guidelines', label: 'Brand Guidelines / CI-Handbuch' },
        { value: 'website_zugang', label: 'Zugang zur bestehenden Website (Admin-Login)' },
        { value: 'sitemap_vorhanden', label: 'Bestehende Sitemap / Seitenstruktur' },
        { value: 'produktkatalog', label: 'Produktkatalog / Produktdaten (CSV, Excel, XML)' },
        { value: 'texte_vorhanden', label: 'Texte & Inhalte (Word, Google Docs…)' },
        { value: 'bilder_vorhanden', label: 'Bilder & Fotos (professionell, druckfähig)' },
        { value: 'videos_vorhanden', label: 'Videos & Animationen' },
        { value: 'technische_doku', label: 'Technische Dokumentation (API-Docs, Systemdoku)' },
        { value: 'api_dokumentation', label: 'API-Zugangsdaten & Schnittstellenbeschreibungen' },
        { value: 'rechtliche_dokumente', label: 'Rechtliche Dokumente (AGB, Datenschutz, Impressum)' },
        { value: 'seo_berichte', label: 'Bestehende SEO-Berichte & Keyword-Analysen' },
        { value: 'analytics_daten', label: 'Google Analytics / Matomo Zugang & Berichte' },
        { value: 'wettbewerber_beispiele', label: 'Referenzbeispiele (Wettbewerber, Inspirationen)' },
        { value: 'mockups_wireframes', label: 'Mockups / Wireframes / Design-Entwürfe' },
        { value: 'hosting_zugaenge', label: 'Hosting- & Server-Zugangsdaten' },
        { value: 'domain_zugaenge', label: 'Domain-Zugangsdaten (Registrar)' }
      ],
      subtitle2: '19.2 Fehlende Unterlagen',
      fehlendeUnterlagen: 'Welche Unterlagen müssen noch erstellt oder beschafft werden?',
      fehlendeUnterlagenPlaceholder: 'z.B. professionelle Fotos müssen noch gemacht werden, Texte werden erst nach Projektstart geliefert…',
      subtitle3: '19.3 Dateiupload',
      dateiUpload: 'Dateien direkt anhängen (max. 10 MB, mehrere Dateien möglich)',
      dateiUploadHelp: 'Erlaubte Formate: PDF, Word, Excel, PowerPoint, ZIP, Bilder (JPG/PNG/SVG/AI/EPS), Video (MP4/MOV)'
    },
    
    // Submit
    submitButton: 'Fragebogen absenden',
    submitting: 'Wird gesendet...',
    submitSuccess: 'Vielen Dank! Ihre Anfrage wurde erfolgreich gesendet.',
    submitError: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
    downloadPdfButton: 'Formular als PDF herunterladen',
    downloadGenerating: 'PDF wird erstellt...',
    downloadEmptyWarning: 'Bitte fuellen Sie zuerst mindestens ein Feld aus.',
    downloadError: 'PDF konnte nicht erstellt werden. Bitte erneut versuchen.',
    pdfTitle: 'Website Anfrage Formular',
    pdfGeneratedOn: 'Erstellt am',
    workflowNoticeTitle: 'Wichtiger Hinweis zum Versand',
    workflowNoticeText: 'Dieses Formular wird nicht direkt online versendet. Laden Sie es als PDF herunter und senden Sie die Datei anschliessend per E-Mail an',
    downloadGuideTitle: 'Naechster Schritt',
    downloadGuideText: 'Bitte senden Sie die heruntergeladene PDF-Datei per E-Mail an:',
    downloadGuideStep1: 'PDF in Ihrem Download-Ordner oeffnen.',
    downloadGuideStep2: 'Neue E-Mail an digitalevit@gmail.com erstellen.',
    downloadGuideStep3: 'PDF-Datei anhaengen und E-Mail absenden.',
    submitResponse: {
      title: 'Danke fuer Ihre Anfrage',
      text: 'Wir haben Ihre Angaben erhalten und melden uns in der Regel innerhalb von 2 Werktagen.',
      emailPrefix: 'Bestaetigung an:',
      cta: 'Neue Anfrage starten'
    },
    required: 'Pflichtfeld'
  },
  
  fr: {
    // French translations (simplified - full translation would be needed)
    title: 'Demande de Site Web',
    subtitle: 'Progrès',
    bitteWaehlen: 'Veuillez sélectionner',
    ui: {
      headerMenuAriaLabel: 'Menu principal',
      headerBadgeAriaLabel: 'Briefing de projet confidentiel',
      headerBadgeText: 'Demande de site web',
      languageMenuLabel: 'Sélection de langue',
      progressAriaLabel: 'Progression du formulaire',
      progressLabel: 'Progression',
      footerOrgLine: 'DiGiTaL e.V. - Digitalisation & innovation pour tous',
      footerProjectLine: 'Demande de site web & documentation projet - Confidentiel',
      footerCopyrightPrefix: 'Copyright 2026 DiGiTaL e.V. - Tous droits réservés -',
      footerPrivacy: 'Confidentialité',
      footerImprint: 'Mentions légales',
      goTopAriaLabel: 'Faire défiler vers le haut',
      goTopLabel: 'Haut'
    },
    
    contact: {
      title: '1. Coordonnées',
      vereinsname: 'Nom de l\'association',
      vereinsnamePlaceholder: 'par ex. Communauté Camerounaise',
      gruendungsjahr: 'Année de fondation',
      ansprechpartner: 'Personne de contact*',
      ansprechpartnerPlaceholder: 'Prénom et nom',
      position: 'Position / Rôle',
      email: 'Adresse e-mail*',
      telefon: 'Téléphone',
      webseite_aktuell: 'Site web actuel',
      standort: 'Localisation',
      adresse: 'Adresse'
    },
    
    projectType: {
      title: '2. Type de projet',
      subtitle1: '2.1 De quoi avez-vous besoin ?',
      neue_website: 'Créer un nouveau site',
      relaunch: 'Refonte complète',
      redesign: 'Mise à jour du design',
      erweiterung: 'Extension des fonctionnalités',
      andere: 'Autre',
      andere_placeholder: 'Veuillez décrire',
      subtitle2: '2.2 Objectif principal',
      beschreibung: 'Description du projet*',
      beschreibungPlaceholder: 'Décrivez brièvement...'
    },
    
    organization: {
      title: '3. Contexte',
      subtitle: 'Contexte commercial et public cible',
      subtitle1: '3.1 Description',
      branche: 'Secteur',
      branchePlaceholder: 'par ex. Association culturelle',
      dienstleistungen: 'Quels services offrez-vous?',
      dienstleistungenPlaceholder: 'Décrivez vos offres...',
      taetigkeitsgebiete: 'Régions d\'activité',
      taetigkeitsgebietePlaceholder: 'par ex. Sarre, Allemagne',
      subtitle2: '3.2 Public cible',
      zielgruppeTyp: 'Qui utilisera le site?',
      zielgruppeOptions: [
        { value: 'privatkunden', label: 'Clients particuliers' },
        { value: 'mitglieder', label: 'Membres' },
        { value: 'interessierte', label: 'Visiteurs intéressés' }
      ],
      zg_alter: 'Groupe d\'âge',
      zg_alterPlaceholder: 'par ex. 25–55 ans',
      zg_standort: 'Localisation',
      zg_standortPlaceholder: 'par ex. Sarre',
      zg_sprache: 'Langue(s)',
      zg_sprachePlaceholder: 'par ex. Français, Allemand',
      zg_technik: 'Niveau technique',
      zg_technikOptions: [
        { value: 'niedrig', label: 'Faible' },
        { value: 'mittel', label: 'Moyen' },
        { value: 'hoch', label: 'Élevé' }
      ],
      zg_beduerfnisse: 'Besoins du public',
      zg_beduerfnissePlaceholder: 'Que recherchent vos visiteurs?',
      subtitle3: '3.3 Concurrence',
      konkurrenz: 'Sites similaires',
      konkurrenz_analyse: 'Analyse de la concurrence',
      konkurrenz_analysePlaceholder: 'Qu\'est-ce qui fonctionne bien?'
    },
    
    // Additional French sections would follow same pattern
    content: { title: '4. Contenu', subtitle: 'Pages et langues', subtitle1: '4.1 Pages', seitenLabel: 'Quelles pages?', seitenOptions: [{ value: 'home', label: 'Accueil' }], seiten_weitere: 'Autres pages', seiten_weiterePlaceholder: 'par ex. FAQ...', subtitle2: '4.2 Langues', sprachenLabel: 'Langues disponibles?', sprachenOptions: [{ value: 'deutsch', label: 'Allemand' }, { value: 'franzoesisch', label: 'Français' }], lang_andere_text: 'Autres langues?', lang_andere_textPlaceholder: 'par ex. Anglais...', content_bereitstellung: 'Qui fournit le contenu?', content_bereitstellungOptions: [{ value: 'wir-liefern-alles', label: 'Nous fournissons tout' }] },
    design: { title: '5. Design', subtitle: 'Apparence du site', subtitle1: '5.1 Style', designStilLabel: 'Quel style?', designStilOptions: [{ value: 'modern-clean', label: 'Moderne & Clean' }], stil_beschreibung: 'Description du style', stil_beschreibungPlaceholder: 'Décrivez...', farbschema: 'Couleurs', farbschemaPlaceholder: 'par ex. Bleu/Blanc...', farbschemaHelp: 'Codes hex bienvenus', subtitle2: '5.2 Marque', brandingVorhandenLabel: 'Matériaux existants?', brandingVorhandenOptions: [{ value: 'logo-hochqualitaet', label: 'Logo haute qualité' }], subtitle3: '5.3 Références', referenzenLabel: 'Sites qui vous plaisent', gefaelltGrundPlaceholder: 'Pourquoi?' },
    features: { title: '6. Fonctionnalités', subtitle: 'Quelles fonctions?', subtitle1: '6.1 Features', featuresLabel: 'Fonctions nécessaires?', featuresOptions: [{ value: 'kontaktformular', label: 'Formulaire de contact' }], features_weitere: 'Autres features', features_weiterePlaceholder: 'par ex. Chat...', subtitle2: '6.2 Formulaires', formulareLabel: 'Quels formulaires?', formulareOptions: [{ value: 'kontakt', label: 'Contact' }], formulare_weitere: 'Autres formulaires', formulare_weiterePlaceholder: 'Décrivez...' },
    tech: { title: '7. Technologie', subtitle: 'Préférences techniques', subtitle1: '7.1 Technologie', technologieLabel: 'Technologie préférée?', technologieOptions: [{ value: 'keine-praeferenz', label: 'Aucune préférence' }, { value: 'wordpress', label: 'WordPress' }], tech_weitere: 'Autre technologie', tech_weiterePlaceholder: 'par ex. Typo3...', subtitle2: '7.2 CMS', cmsBenoetigt: 'Gérer le contenu vous-même?', cmsOptions: [{ value: 'ja', label: 'Oui' }, { value: 'nein', label: 'Non' }], cmsNutzerLabel: 'Qui gérera le CMS?', cmsNutzerOptions: [{ value: 'vorstand', label: 'Direction' }], subtitle3: '7.3 Intégrations', integrationenLabel: 'Systèmes à intégrer?', integrationenOptions: [{ value: 'crm', label: 'Système CRM' }], integrationen_liste: 'Détails des intégrations', integrationen_listePlaceholder: 'Décrivez...' },
    timeline: { title: '15. Calendrier & Budget', subtitle: 'Quand et combien?', launch_zeitraum: 'Délai souhaité', launch_zeitraumOptions: [{ value: 'sofort', label: 'Dès que possible' }, { value: '3_6_monate', label: '3–6 mois' }], launch_datum: 'Date de lancement', deadline_grund: 'Raison de la deadline', deadline_grundPlaceholder: 'par ex. Événement...', budget_rahmen: 'Budget', budget_rahmenOptions: [{ value: 'unter-5k', label: 'Moins de 5.000 €' }, { value: '5k-15k', label: '5.000 € – 15.000 €' }], budget_aufteilung: 'Répartition du budget', budget_aufteilungPlaceholder: 'par ex. 40% design...' },
    shop: { title: '8. E-Commerce', subtitle: 'Exigences boutique en ligne', shopBenoetigt: 'Boutique en ligne nécessaire?', shopOptionen: [{ value: 'ja', label: 'Oui' }, { value: 'nein', label: 'Non' }], subtitle1: '8.1 Produits', produktAnzahl: 'Nombre de produits', produktAnzahlOptionen: [{ value: '1-10', label: '1–10' }], produktTyp: 'Type de produits', produktTypOptionen: [{ value: 'physische-produkte', label: 'Produits physiques' }], subtitle2: '8.2 Fonctionnalités', shopFeatures: 'Fonctionnalités boutique', shopFeaturesOptionen: [{ value: 'warenkorb', label: 'Panier' }], zahlungsmethoden: 'Méthodes de paiement', zahlungsmethodenOptionen: [{ value: 'paypal', label: 'PayPal' }], zahlungsmethodenWeitere: 'Autres...', versandanbieter: 'Fournisseur d\'expédition', versandanbieterPlaceholder: 'DHL, DPD...' },
    compliance: { title: '9. Sécurité & RGPD', subtitle: 'Conformité et protection des données', subtitle1: '9.1 Conformité', complianceAnforderungen: 'Exigences légales', complianceOptionen: [{ value: 'dsgvo', label: 'RGPD' }], complianceWeitere: 'Autres', complianceWeiterePlaceholder: 'Précisez...', subtitle2: '9.2 Sécurité', sicherheitsFeatures: 'Fonctions de sécurité', sicherheitOptionen: [{ value: 'ssl-https', label: 'SSL / HTTPS' }], sensibleDaten: 'Données sensibles?', sensibleDatenOptionen: [{ value: 'personendaten', label: 'Données personnelles' }], datenschutzAnmerkungen: 'Remarques', datenschutzAnmerkungenPlaceholder: 'Spécifications...' },
    seo: { title: '10. SEO & Marketing', subtitle: 'Optimisation moteurs de recherche', subtitle1: '10.1 SEO', seoLeistungen: 'Services SEO', seoOptionen: [{ value: 'technisches-seo', label: 'SEO technique' }], seoKeywords: 'Mots-clés', seoKeywordsPlaceholder: 'Vos termes de recherche...', seoKeywordsHelp: 'Plus de détails = meilleure stratégie', seoZielregion: 'Région cible', seoZielregionPlaceholder: 'Allemagne, Europe...', subtitle2: '10.2 Outils marketing', marketingTools: 'Outils marketing', marketingToolsOptionen: [{ value: 'google-analytics-4', label: 'Google Analytics 4' }], socialMedia: 'Réseaux sociaux', socialMediaOptionen: [{ value: 'facebook', label: 'Facebook' }], socialMediaUrls: 'URLs réseaux sociaux...' },
    performance: { title: '11. Performance & Hébergement', subtitle: 'Trafic et exigences', subtitle1: '11.1 Hébergement', hostingStatus: 'Hébergement existant?', hostingStatusOptionen: [{ value: 'nein', label: 'Non' }], hostingTyp: 'Type d\'hébergement', hostingTypOptionen: [{ value: 'cloud-hosting', label: 'Cloud' }], hostingTypHelp: 'Recommandé: serveurs EU', emailHosting: 'E-mails professionnelles?', emailHostingOptionen: [{ value: 'ja', label: 'Oui' }], subtitle2: '11.2 Performance', traffic: 'Visiteurs mensuels', trafficOptionen: [{ value: '1000-10000', label: '1.000–10.000' }], performanceAnforderungen: 'Exigences performance', performanceOptionen: [{ value: 'schnelle-ladezeit', label: 'Chargement rapide' }] },
    accessibility: { title: '12. Accessibilité', subtitle: 'Accessible à tous les utilisateurs', barrierefreiheitNiveau: 'Niveau d\'accessibilité', barrierefreiheitOptionen: [{ value: 'basis', label: 'Base' }], a11yFeatures: 'Fonctionnalités', a11yFeaturesOptionen: [{ value: 'tastaturnavigation', label: 'Navigation clavier' }] },
    migration: { title: '13. Migration', subtitle: 'Données existantes', subtitle1: '13.1 Site existant', migrationUrl: 'URL actuelle', migrationBenoetigt: 'Migration nécessaire?', migrationOptionen: [{ value: 'nein', label: 'Non' }], subtitle2: '13.2 Contenu à migrer', migrationInhalteOptionen: [{ value: 'seiten', label: 'Pages' }], subtitle3: '13.3 Plateforme actuelle', aktuellePlattform: 'Plateforme?', plattformOptionen: [{ value: 'wordpress', label: 'WordPress' }], plattformAndere: 'Autre plateforme', plattformAnderePlaceholder: 'Nom...', migrationNotizen: 'Remarques', migrationNotizenPlaceholder: 'Spécifications...' },
    support: { title: '14. Maintenance & Support', subtitle: 'Suivi après lancement', subtitle1: '14.1 Services', supportLeistungenOptionen: [{ value: 'basis_wartung', label: 'Maintenance de base' }], subtitle2: '14.2 Modèle', supportModell: 'Organisation support', supportModellOptionen: [{ value: 'monatlich_retainer', label: 'Forfait mensuel' }], subtitle3: '14.3 Documentation', uebergabeOptionen: [{ value: 'admin_schulung', label: 'Formation admin' }] },
    priorities: { title: '16. Priorités', subtitle: 'Évaluez les critères', subtitle1: '16.1 Pondération', unwichtig: 'Pas important', mittel: 'Moyen', sehrWichtig: 'Très important', priorityItems: [{ field: 'prio_preis', label: 'Prix' }, { field: 'prio_design', label: 'Design' }], subtitle2: '16.2 Décision', entscheidungsgrund: 'Critère principal', entscheidungsgrundOptionen: [{ value: 'preis', label: 'Prix' }] },
    stakeholders: { title: '17. Processus interne', subtitle: 'Décisions et feedback', subtitle1: '17.1 Feedback', feedbackPersonen: 'Qui donne le feedback?', feedbackPersonenPlaceholder: 'Direction, marketing...', feedbackGeschwindigkeit: 'Délai feedback', feedbackGeschwindigkeitOptionen: [{ value: '1_2_tage', label: '1–2 jours' }], feedbackRunden: 'Nombre de tours', feedbackRundenOptionen: [{ value: '2', label: '2 tours' }], subtitle2: '17.2 Parties prenantes', stakeholderBereiche: 'Départements impliqués', stakeholderOptionen: [{ value: 'marketing', label: 'Marketing' }], subtitle3: '17.3 Communication', kommunikationsweg: 'Canal préféré', kommunikationOptionen: [{ value: 'email', label: 'E-mail' }], updateFrequenz: 'Fréquence mises à jour', updateFrequenzOptionen: [{ value: 'woechentlich', label: 'Hebdomadaire' }] },
    additional: { title: '18. Informations supplémentaires', subtitle: 'Détails complémentaires', subtitle1: '18.1 Souhaits particuliers', besondereWuensche: 'Souhaits spéciaux', besondereWuenschePlaceholder: 'Technologies, fonctions...', subtitle2: '18.2 Défis actuels', herausforderungen: 'Défis actuels', herausforderungenPlaceholder: 'Problèmes avec le site actuel...', subtitle3: '18.3 Mesure du succès', erfolgsMessung: 'Mesure du succès', erfolgsMessungPlaceholder: 'Métriques importantes...', kpis: 'KPIs', kpisPlaceholder: 'Visiteurs, conversions...', subtitle4: '18.4 Services additionnels', zusatzleistungenOptionen: [{ value: 'wartung', label: 'Maintenance' }], subtitle5: '18.5 Autres', sonstiges: 'Autres informations', sonstigesPlaceholder: 'Tout ce que vous voulez ajouter...' },
    files: { title: '19. Fichiers & Annexes', subtitle: 'Matériaux disponibles', subtitle1: '19.1 Documents disponibles', verfuegbareHelp: 'Veuillez cocher ce qui est déjà disponible et peut être fourni.', verfuegbareLabel: 'Quels documents peuvent être fournis?', unterlagenOptionen: [{ value: 'logo', label: 'Logo (fichier vectoriel / SVG / AI / EPS)' }, { value: 'brand_guidelines', label: 'Charte graphique / Manuel CI' }, { value: 'website_zugang', label: 'Accès au site existant (login admin)' }, { value: 'sitemap_vorhanden', label: 'Plan du site / Structure existante' }, { value: 'produktkatalog', label: 'Catalogue produits / Données (CSV, Excel, XML)' }, { value: 'texte_vorhanden', label: 'Textes & contenus (Word, Google Docs…)' }, { value: 'bilder_vorhanden', label: 'Images & photos (professionnelles, haute résolution)' }, { value: 'videos_vorhanden', label: 'Vidéos & animations' }, { value: 'technische_doku', label: 'Documentation technique (API-Docs, doc système)' }, { value: 'api_dokumentation', label: 'Accès API & descriptions d\'interfaces' }, { value: 'rechtliche_dokumente', label: 'Documents juridiques (CGV, confidentialité, mentions légales)' }, { value: 'seo_berichte', label: 'Rapports SEO & analyses de mots-clés existants' }, { value: 'analytics_daten', label: 'Accès Google Analytics / Matomo & rapports' }, { value: 'wettbewerber_beispiele', label: 'Exemples de référence (concurrents, inspirations)' }, { value: 'mockups_wireframes', label: 'Maquettes / Wireframes / Esquisses de design' }, { value: 'hosting_zugaenge', label: 'Accès hébergement & serveur' }, { value: 'domain_zugaenge', label: 'Accès domaine (registrar)' }], subtitle2: '19.2 Documents manquants', fehlendeUnterlagen: 'Quels documents doivent encore être créés ou obtenus?', fehlendeUnterlagenPlaceholder: 'par ex. photos professionnelles à faire, textes livrés après début projet…', subtitle3: '19.3 Téléchargement de fichiers', dateiUpload: 'Joindre des fichiers directement (max. 10 MB, plusieurs fichiers possibles)', dateiUploadHelp: 'Formats autorisés: PDF, Word, Excel, PowerPoint, ZIP, Images (JPG/PNG/SVG/AI/EPS), Vidéo (MP4/MOV)' },
    
    submitButton: 'Envoyer',
    submitting: 'Envoi...',
    submitSuccess: 'Merci! Demande envoyée.',
    submitError: 'Erreur. Réessayez.',
    downloadPdfButton: 'Telecharger le formulaire en PDF',
    downloadGenerating: 'Generation du PDF...',
    downloadEmptyWarning: 'Veuillez remplir au moins un champ avant de telecharger.',
    downloadError: 'Impossible de generer le PDF. Veuillez reessayer.',
    pdfTitle: 'Formulaire de demande de site web',
    pdfGeneratedOn: 'Genere le',
    workflowNoticeTitle: 'Information importante sur lenvoi',
    workflowNoticeText: 'Ce formulaire nest pas envoye directement en ligne. Telechargez-le en PDF puis envoyez le fichier par e-mail a',
    downloadGuideTitle: 'Etape suivante',
    downloadGuideText: 'Veuillez envoyer le PDF telecharge par e-mail a :',
    downloadGuideStep1: 'Ouvrez le PDF dans votre dossier de telechargement.',
    downloadGuideStep2: 'Creez un nouvel e-mail a digitalevit@gmail.com.',
    downloadGuideStep3: 'Ajoutez le PDF en piece jointe puis envoyez votre e-mail.',
    submitResponse: {
      title: 'Merci pour votre demande',
      text: 'Nous avons bien recu vos informations et revenons vers vous sous 2 jours ouvrables en general.',
      emailPrefix: 'Confirmation envoyee a :',
      cta: 'Demarrer une nouvelle demande'
    },
    required: 'Obligatoire'
  }
}
